// @flow
import { createContext } from 'react';

export type InboxButtonContextType = {|
  inboxButton: ?HTMLElement,
  setInboxButton: (ref: ?HTMLElement) => void,
  profileInboxButton: ?HTMLElement,
  setProfileInboxButton: (ref: ?HTMLElement) => void,
|};

export default createContext<InboxButtonContextType>({
  inboxButton: null,
  setInboxButton: (ref: ?HTMLElement) => {},
  profileInboxButton: null,
  setProfileInboxButton: (ref: ?HTMLElement) => {},
});
